import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StoreRootState } from 'services/store/types';

const useSongStructure = (id?: number | null) => {
  const structures = useSelector(
    (store: StoreRootState) => store.ai.structures
  );
  const structure = useMemo(() => {
    if (id === undefined) {
      return null;
    }
    return Object.values(structures).find((item) => item.id === id) || null;
  }, [id, structures]);
  return structure;
};

export default useSongStructure;
